import {call, put, takeLatest} from 'redux-saga/effects'

import * as report from '../../report'
import {
  GET_SHOWROOM_LOCATION,
  getShowroomLocationFailure,
  getShowroomLocationPending,
  getShowroomLocationSuccess,
} from '../../actions/showrooms/detail'
import {getShowroomLocation} from '../../api/showrooms'
import {onStatus} from '../../api/api'

/**
 * Handles the API call to our server for getting a showroom location
 *
 * @param {string} showroomSlug The slug of the showroom location to get
 */
export function* getShowroomLocationWorker({payload: {showroomSlug}}) {
  try {
    yield put(getShowroomLocationPending())

    const response = yield call(getShowroomLocation, showroomSlug)

    const location = onStatus({
      OK: ({json}) => json,
      DEFAULT: ({statusText}) => {
        throw new Error(`Could not get showroom location: ${statusText}`)
      },
    })(response)

    yield put(getShowroomLocationSuccess(location))
  } catch (e) {
    report.exception(e)
    yield put(getShowroomLocationFailure(new Error('Could not get showroom location.')))
  }
}

export function* getShowroomLocationSaga() {
  yield takeLatest(GET_SHOWROOM_LOCATION, getShowroomLocationWorker)
}
